import { CheckIcon } from "@phosphor-icons/react/Check";
import { DesktopIcon } from "@phosphor-icons/react/Desktop";
import { MoonIcon } from "@phosphor-icons/react/Moon";
import { SunIcon } from "@phosphor-icons/react/Sun";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { useThemeContext } from "@freightsimple/ui-core/Theme/useThemeContext";
import type { Theme } from "@freightsimple/ui-core/Theme/useTheme";

const options = [
  { value: "light", label: "Light", icon: SunIcon },
  { value: "dark", label: "Dark", icon: MoonIcon },
  { value: "system", label: "System", icon: DesktopIcon },
] as const satisfies readonly {
  value: Theme;
  label: string;
  icon: typeof SunIcon;
}[];

/**
 * The Light / Dark / System rows, with a check on the active choice.
 *
 * Split out from `NavBarThemeMenu` because the signed-out header has no user
 * menu to nest a submenu inside — it puts these straight into its own menu. The
 * two headers are separate components (see NavBar), so without sharing this the
 * signed-out picker drifts from the signed-in one.
 */
export function NavBarThemeMenuItems() {
  const { theme, setTheme } = useThemeContext();

  return (
    <>
      {options.map((option) => (
        <Button
          key={option.value}
          data-testid={`theme-${option.value}-menu-option`}
          icon={theme === option.value ? CheckIcon : option.icon}
          onClick={() => setTheme(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </>
  );
}
